import React, { Component } from 'react';
import { Form, FormGroup, Label, Input, Button, FormFeedback, Table, TabContent, TabPane, Nav, NavItem, NavLink } from 'reactstrap';
import { Field, reduxForm } from 'redux-form';
import classnames from 'classnames';
import { Link } from 'react-router-dom';


const validate = values => {
    const errors = {}
    if (!values.fullname) {
        errors.fullname = 'Trường này không được để trống'
    }
    return errors
}

const InputField = ({ required, placeholder, disabled, input, label, type, meta: { touched, error, dirty } }) => (
    <FormGroup>
        <Label for={label}><strong>{label}</strong> {required ? <span style={{ color: "red" }}>*</span> : ''}</Label>
        <Input invalid={touched && !!error && dirty} placeholder={placeholder} disabled={disabled} {...input} type={type} />
        <FormFeedback>{error}</FormFeedback>
    </FormGroup>
)

class User extends Component {

    constructor(props) {
        super(props);
        this.state = {
            visible: false,
            message: '',
            alertType: '',
            activeTab: '1'
        }
    }

    toggle = (tab) => {
        if (this.state.activeTab !== tab) {
            this.setState({
                activeTab: tab
            });
        }
    }

    onSubmit = (data) => {
        const { id, fullname } = data

        const userInput = { id, fullname }

        this.props.mutate({
            variables: { userInput },
        })
            .then(({ data }) => {
                if (data.updateUser) {
                    this.setState({
                        visible: true,
                        message: 'Cập nhật thành công',
                        alertType: 'success'
                    })
                }
            })
            .catch(({ error }) => {
                this.setState({
                    visible: true,
                    message: 'Cập nhật không thành công',
                    alertType: 'danger'
                })
            })

    }

    onDismiss = () => {
        this.setState({
            visible: false
        })
    }

    generateMedias = (medias) => {
        return [...medias].map((item, index) => {
            return <tr key={index}>
                <th scope="row">{index + 1}</th>
                <td><Link to={"/media/watch/" + item.id} >{item.name}</Link></td>
                <td>{item.scoin}</td>
            </tr>
        })
    }

    generateUserPackage = (user_package) => {
        return [...user_package].map((item, index) => {
            return <tr key={index}>
                <th scope="row">{index + 1}</th>
                <td><Link to={"/package-detail/" + item.package.id} >{item.package.title}</Link></td>
                <td>{new Date(item.endday).toLocaleString()}</td>
            </tr>
        })
    }

    render() {
        if (this.props.getUser.loading) return 'Loading...'
        if (this.props.getUser.error) return 'Error fetch'

        let user = this.props.getUser.getUser;
        let medias = user.medias;
        let user_package = user.user_package;
        const { handleSubmit, submitting, pristine } = this.props;

        return (
            <div className="container">
                <h4 className="text-center">THÔNG TIN TÀI KHOẢN</h4>
                <hr />
                <div className="row">
                    <div className="col-md-4 col-md-offset-4">
                        {
                            this.state.visible ?
                                <div className={`alert alert-${this.state.alertType} alert-dismissible`} role="alert">
                                    <button
                                        type="button"
                                        onClick={this.onDismiss}
                                        className="close"
                                        data-dismiss="alert"
                                        aria-label="Close"
                                    ><span aria-hidden="true">&times;</span></button>
                                    {this.state.message}
                                </div>
                                :
                                null
                        }

                        <Form className="profile-form" onSubmit={handleSubmit(data => this.onSubmit(data))} >
                            <Field name="id" type="hidden" component={InputField} />
                            <Field name="email" type="text" component={InputField} label="Email" disabled />
                            <Field name="fullname" type="text" component={InputField} label="Họ và tên" />
                            <div>
                                <Nav tabs>
                                    <NavItem>
                                        <NavLink
                                            className={classnames({ active: this.state.activeTab === '1' })}
                                            onClick={() => { this.toggle('1'); }}
                                        >
                                            Media đã mua
                                        </NavLink>
                                    </NavItem>
                                    <NavItem>
                                        <NavLink
                                            className={classnames({ active: this.state.activeTab === '2' })}
                                            onClick={() => { this.toggle('2'); }}
                                        >
                                            Gói đã mua
                                        </NavLink>
                                    </NavItem>
                                    <NavItem>
                                        <NavLink
                                            className={classnames({ active: this.state.activeTab === '3' })}
                                            onClick={() => { this.toggle('3'); }}
                                        >
                                            Ngày xem
                                        </NavLink>
                                    </NavItem>
                                </Nav>
                                <TabContent activeTab={this.state.activeTab}>
                                    <TabPane tabId="1">
                                        <Table>
                                            <thead>
                                                <tr>
                                                    <th colSpan="3">Media đã mua</th>
                                                </tr>
                                                <tr>
                                                    <th>#</th>
                                                    <th>Tên media</th>
                                                    <th>Scoin</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {medias && medias.length > 0 ? this.generateMedias(medias) : <tr><td colSpan="3">Bạn chưa mua media nào</td></tr>}
                                            </tbody>
                                        </Table>
                                    </TabPane>
                                    <TabPane tabId="2">
                                        <Table>
                                            <thead>
                                                <tr>
                                                    <th colSpan="3">Gói đã mua</th>
                                                </tr>
                                                <tr>
                                                    <th>#</th>
                                                    <th>Tên gói</th>
                                                    <th>Ngày hết hạn</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {user_package && user_package.length > 0 ? this.generateUserPackage(user_package) : <tr><td colSpan="3">Bạn chưa mua gói nào</td></tr>}
                                            </tbody>
                                        </Table>
                                    </TabPane>
                                    <TabPane tabId="3">
                                        <Table>
                                            <thead>
                                                <tr>
                                                    <th>Ngày xem</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr><td>{user.endday ? new Date(user.endday).toLocaleString() : 'Bạn chưa mua ngày xem'}</td></tr>
                                            </tbody>
                                        </Table>
                                    </TabPane>
                                </TabContent>
                            </div>
                            <FormGroup>
                                <Label>Thông tin thanh toán</Label>
                                <p className="text-center">Thông tin đang cập nhật</p>
                            </FormGroup>
                            <Button type="submit" disabled={submitting || pristine} color="primary" block>Cập nhật</Button>
                        </Form>
                    </div>
                </div>
            </div>
        )
    }
}

export default reduxForm({
    form: 'EditProfile',
    validate
})(User)



// WEBPACK FOOTER //
// ./src/components/Users/User.js